import getBG from '../../utils/utils';

export default {
    name: 'cloud-system-trial',
    data() {
        return {
            demand: {
                systemType: []
            },
            rules: {
                contractsName: [{ required: true, message: '联系人姓名' }],
                systemType: [{ required: true, message: '系统类型' }],
                companyName: [{ required: true, message: '公司名称' }],
                mobile: [{ required: true, message: '联系人电话' }],
                email: [{ required: true, message: '邮箱地址' }]
            },
            systems: [],
            backgroundImage: '',
            loading: false
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            this.getSystemType();
            this.backgroundImage = await getBG.call(this, 'CloudSystemTrial');
        },
        // 查询系统类型
        getSystemType() {
            this.$http
                .fetchData('codes/getCodesList', {
                    category: 'SystemType'
                })
                .then(res => {
                    console.log(res);
                    this.systems = [];
                    if (res && res.length > 0) {
                        this.systems = res.filter(item => {
                            // 市场部要求只显示 云前台系统，云长租系统，云会员系统，钉钉版PMS
                            return (
                                item.code === 'iPMS' ||
                                item.code === 'iPOS' ||
                                item.code === 'iCRM' ||
                                item.code === 'iSCM' ||
                                item.code === 'iCOUPON' ||
                                item.code === 'iESP'
                            );
                        });
                    }
                })
                .catch(err => {
                    this.$message({
                        message: err,
                        type: 'error'
                    });
                });
        },
        // 提交云系统试用
        addCloudSystemTrail() {
            // 增加输入校验
            // if (!this.demand || !this.demand.contractsName || this.demand.contractsName.length < 2) {
            //     this.$message({
            //         message: '请填写正确的联系人',
            //         type: 'error'
            //     });
            //     return;
            // }

            // if (
            //     !this.demand ||
            //     !this.demand.companyName ||
            //     this.demand.companyName.length < 4 ||
            //     this.demand.companyName.length > 20
            // ) {
            //     this.$message({
            //         message: '请填下正确的公司名称',
            //         type: 'error'
            //     });
            //     return;
            // }

            // if (!this.demand || !this.demand.mobile || this.demand.mobile.length < 11) {
            //     console.log('2222');
            //     this.$message({
            //         message: '请填写正确的手机号码',
            //         type: 'error'
            //     });
            //     return;
            // }

            // const chinaPhoneNumberRegex = /^1[3-9]\d{9}$/;
            // // 示例：校验中国大陆的手机号码
            // if (!chinaPhoneNumberRegex.test(this.demand.mobile)) {
            //     console.log('1111', this.demand.mobile);
            //     this.$message({
            //         message: '请填写正确的手机号码',
            //         type: 'error'
            //     });
            //     return;
            // }
            const arr = [];
            console.log(this.$refs);
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true;

                    if (this.demand.systemType.length > 0) {
                        this.demand.systemType.forEach(item => {
                            this.systems.forEach(system => {
                                if (item === system.name) {
                                    item = system.code;
                                    arr.push(system.code);
                                }
                            });
                        });
                        this.demand.systemType = arr.join(',');
                    } else {
                        this.demand.systemType = arr.join(',');
                    }
                    this.$http
                        .fetchData('cloudSystemTrail/addCloudSystemTrail', {
                            ...this.demand,
                            systemType: this.demand.systemType
                        })
                        .then(res => {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.loading = false;
                            this.demand = {
                                systemType: []
                            };
                        })
                        .catch(err => {
                            console.log(err);
                            this.$message({
                                message: err,
                                type: 'error'
                            });
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 重置
        reset() {
            this.demand = {
                systemType: []
            };
        }
    }
};
